// extracted by mini-css-extract-plugin
export default {"main":"ShowcaseMain_main__+D8KT"};